export default{
    getChildrenList: state => state.list,
    getChildrenValidation: state => state.validation,
    getChildrenFilter: state => state.filter,

}